import { ArrowRight, CheckCircle2, Phone, Calendar, FileCheck, Package, Truck, Home, ClipboardCheck, Shield, Clock, Users, ChevronDown } from 'lucide-react';
import { useEffect } from 'react';
import Contact from '../components/Contact';
import FAQ from '../components/FAQ';

export default function Ablauf() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollDown = () => {
    window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
  };

  const processSteps = [
    {
      number: '01',
      icon: Phone,
      title: 'Erstkontakt & Beratung',
      description: 'Sie kontaktieren uns telefonisch, per E-Mail oder über unser Kontaktformular. Wir beraten Sie kostenlos und unverbindlich zu Ihrem Umzug von der Schweiz nach Deutschland.',
      duration: '15-30 Min',
      details: [
        'Kostenlose telefonische Erstberatung',
        'Klärung Ihrer individuellen Anforderungen',
        'Besprechung des Umfangstermin',
        'Terminvereinbarung für Besichtigung',
      ],
    },
    {
      number: '02',
      icon: Calendar,
      title: 'Besichtigung & Offerte',
      description: 'Ein Umzugsexperte besichtigt Ihr Umzugsgut vor Ort oder per Video-Call. Anschließend erhalten Sie eine detaillierte Fixpreis-Offerte ohne versteckte Kosten.',
      duration: '1-2 Tage',
      details: [
        'Besichtigung vor Ort oder per Video',
        'Genaue Volumenberechnung',
        'Fixpreis-Offerte innerhalb 24h',
        'Transparente Kostenaufstellung',
      ],
    },
    {
      number: '03',
      icon: FileCheck,
      title: 'Auftragsbestätigung & Planung',
      description: 'Nach Ihrer Zusage planen wir den Umzug detailliert. Wir kümmern uns um alle Zollformalitäten und erstellen einen präzisen Zeitplan für Ihren Umzug.',
      duration: '3-5 Tage',
      details: [
        'Auftragsbestätigung und Vertrag',
        'Detaillierte Umzugsplanung',
        'Erstellung aller Zolldokumente',
        'Koordination des Umzugstermins',
      ],
    },
    {
      number: '04',
      icon: Package,
      title: 'Verpackung & Vorbereitung',
      description: 'Optional übernehmen wir die professionelle Verpackung Ihres Hausrats. Auf Wunsch liefern wir Ihnen auch Verpackungsmaterial für die Eigenverpackung.',
      duration: '1-2 Tage',
      details: [
        'Lieferung von Verpackungsmaterial',
        'Professioneller Verpackungsservice (optional)',
        'Möbeldemontage bei Bedarf',
        'Sicherung empfindlicher Gegenstände',
      ],
    },
    {
      number: '05',
      icon: Truck,
      title: 'Transport & Zollabwicklung',
      description: 'Wir verladen Ihr Umzugsgut professionell und sicher. Die komplette Zollabwicklung an der Grenze übernehmen wir für Sie – ohne dass Sie vor Ort sein müssen.',
      duration: '1-2 Tage',
      details: [
        'Professionelles Be- und Entladen',
        'Komplette Zollabwicklung',
        'Versicherter Transport nach Deutschland',
        'Direkttransport ohne Umladung',
      ],
    },
    {
      number: '06',
      icon: Home,
      title: 'Ankunft & Möbelmontage',
      description: 'An Ihrer neuen Adresse in Deutschland stellen wir alle Möbel auf und montieren sie fachgerecht. Wir räumen alle Verpackungsmaterialien wieder weg.',
      duration: '1 Tag',
      details: [
        'Entladung am Zielort',
        'Professionelle Möbelmontage',
        'Platzierung nach Ihren Wünschen',
        'Entsorgung des Verpackungsmaterials',
      ],
    },
    {
      number: '07',
      icon: ClipboardCheck,
      title: 'Abschluss & Übergabe',
      description: 'Nach erfolgreichem Umzug prüfen wir gemeinsam mit Ihnen die Vollständigkeit. Sie erhalten alle Dokumente und die Rechnung. Ihr Umzug ist abgeschlossen.',
      duration: '30 Min',
      details: [
        'Gemeinsame Übergabekontrolle',
        'Übergabe aller Zolldokumente',
        'Rechnungsstellung',
        'Zufriedenheitskontrolle',
      ],
    },
  ];

  const timeline = [
    {
      phase: 'Vorbereitung',
      duration: '1-2 Wochen',
      description: 'Planung, Besichtigung und Organisation',
    },
    {
      phase: 'Umzugstag',
      duration: '1-2 Tage',
      description: 'Verpackung, Transport und Zollabwicklung',
    },
    {
      phase: 'Einzug',
      duration: '1 Tag',
      description: 'Entladung, Aufbau und Einrichtung',
    },
  ];

  const benefits = [
    'Persönlicher Ansprechpartner während des gesamten Umzugs',
    'Detaillierter Zeitplan mit festen Terminen',
    'Professionelles Team mit langjähriger Erfahrung',
    'Komplette Koordination von A bis Z',
    'Flexible Anpassung an Ihre Bedürfnisse',
    'Transparente Kommunikation in allen Phasen',
  ];

  const serviceFeatures = [
    {
      icon: Shield,
      title: 'Vollständig versichert',
      description: 'Ihr Umzugsgut ist während des gesamten Transports versichert.',
    },
    {
      icon: Clock,
      title: 'Pünktlichkeit garantiert',
      description: 'Wir halten alle vereinbarten Termine zuverlässig ein.',
    },
    {
      icon: Users,
      title: 'Erfahrenes Team',
      description: 'Geschulte Umzugsprofis mit jahrelanger Erfahrung.',
    },
    {
      icon: FileCheck,
      title: 'Zoll inklusive',
      description: 'Komplette Zollabwicklung ohne Mehraufwand für Sie.',
    },
  ];

  return (
    <div className="min-h-screen">
      <section className="relative pt-24 md:pt-32 pb-24 min-h-[700px] bg-gradient-to-br from-slate-50 via-white to-slate-50 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-slate-500/5 animate-gradient"></div>
          <img
            src="/umzugsunternehmen-schweiz-deutschland.jpeg"
            alt="Umzug Ablauf Schweiz Deutschland"
            className="w-full h-full object-cover opacity-10"
          />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 bg-green-50 text-green-700 px-4 py-2 rounded-full mb-6 border border-green-200 animate-fade-in hover:scale-105 transition-transform duration-300">
              <CheckCircle2 className="w-4 h-4" />
              <span className="text-sm font-semibold">Professioneller Ablauf in 7 Schritten</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 leading-tight animate-fade-in-delay">
              Umzugsablauf
              <span className="block text-slate-700 text-4xl md:text-5xl mt-2">
                Schweiz → Deutschland
              </span>
            </h1>

            <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto leading-relaxed animate-fade-in-delay-2">
              Von der ersten Kontaktaufnahme bis zur Schlüsselübergabe: Erfahren Sie, wie Ihr Umzug von der Schweiz nach Deutschland reibungslos und stressfrei abläuft.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 mb-12 animate-fade-in-delay-2">
              <button
                onClick={scrollToContact}
                className="group bg-slate-800 hover:bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105 flex items-center space-x-2 text-lg"
              >
                <span>Jetzt Umzug planen</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <a
                href="tel:0800700100"
                className="bg-white hover:bg-slate-50 text-slate-800 px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-md hover:shadow-xl hover:scale-105 border-2 border-slate-800"
              >
                0800 700 100 (Gratis)
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto mb-20">
              <div className="bg-white rounded-xl p-6 shadow-md border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-fade-in-delay-2">
                <div className="text-3xl font-bold text-slate-800 mb-1">7</div>
                <div className="text-slate-600 text-sm">Schritte zum Erfolg</div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-fade-in-delay-2">
                <div className="text-3xl font-bold text-slate-800 mb-1">100%</div>
                <div className="text-slate-600 text-sm">Stressfrei & organisiert</div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-fade-in-delay-2">
                <div className="text-3xl font-bold text-slate-800 mb-1">24h</div>
                <div className="text-slate-600 text-sm">Offerte nach Besichtigung</div>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
          <button
            onClick={scrollDown}
            className="animate-bounce bg-white hover:bg-slate-50 text-slate-800 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-slate-200"
            aria-label="Scroll down"
          >
            <ChevronDown className="w-6 h-6" />
          </button>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8 text-center">
              Ihr Umzug in 7 einfachen Schritten
            </h2>

            <div className="prose prose-lg max-w-none text-slate-700 mb-12">
              <p className="text-xl leading-relaxed text-center">
                Wir begleiten Sie durch jeden Schritt Ihres <strong>Umzugs von der Schweiz nach Deutschland</strong>. Von der ersten Beratung bis zur finalen Übergabe sorgen wir für einen reibungslosen und stressfreien Ablauf.
              </p>
            </div>
          </div>

          <div className="max-w-5xl mx-auto space-y-8">
            {processSteps.map((step, index) => {
              const Icon = step.icon;
              const isEven = index % 2 === 0;

              return (
                <div
                  key={index}
                  className={`relative bg-slate-50 rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-800 transition-all duration-300 hover:shadow-xl ${
                    isEven ? 'md:mr-12' : 'md:ml-12'
                  }`}
                >
                  <div className="absolute -left-4 top-8 w-20 h-20 bg-slate-800 rounded-2xl flex items-center justify-center text-white font-bold text-2xl shadow-xl z-10">
                    {step.number}
                  </div>

                  <div className="md:pl-20">
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <div className="bg-slate-800 w-12 h-12 rounded-xl flex items-center justify-center">
                            <Icon className="w-6 h-6 text-white" />
                          </div>
                          <h3 className="text-2xl font-bold text-slate-900">
                            {step.title}
                          </h3>
                        </div>
                      </div>
                      <div className="bg-green-50 text-green-700 px-3 py-1 rounded-lg text-sm font-semibold border border-green-200 whitespace-nowrap ml-4">
                        {step.duration}
                      </div>
                    </div>

                    <p className="text-slate-600 leading-relaxed mb-6 text-lg">
                      {step.description}
                    </p>

                    <ul className="grid md:grid-cols-2 gap-3">
                      {step.details.map((detail, idx) => (
                        <li key={idx} className="flex items-start space-x-2">
                          <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                          <span className="text-slate-700 text-sm">{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {index < processSteps.length - 1 && (
                    <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 z-0">
                      <ArrowRight className="w-8 h-8 text-slate-300 rotate-90" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8 text-center">
              Zeitlicher Ablauf Ihres Umzugs
            </h2>
            <p className="text-xl text-slate-600 text-center">
              So lange dauert Ihr Umzug von der Planung bis zum Einzug
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {timeline.map((phase, index) => (
              <div
                key={index}
                className="relative bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-800 transition-all duration-300 hover:shadow-xl hover:-translate-y-2"
              >
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-800 text-white rounded-2xl text-2xl font-bold mb-4">
                    {index + 1}
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">
                    {phase.phase}
                  </h3>
                  <div className="text-green-600 font-bold text-lg mb-3">
                    {phase.duration}
                  </div>
                  <p className="text-slate-600">
                    {phase.description}
                  </p>
                </div>

                {index < timeline.length - 1 && (
                  <div className="hidden md:block absolute -right-4 top-1/2 transform -translate-y-1/2 z-10">
                    <ArrowRight className="w-8 h-8 text-slate-300" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8 text-center">
              Was unseren Ablauf besonders macht
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12">
            {serviceFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="bg-slate-50 rounded-xl p-6 border-2 border-slate-100 hover:border-slate-800 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                >
                  <div className="bg-slate-800 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="font-bold text-slate-900 mb-2 text-lg">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-100">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">
                Ihre Vorteile bei unserem Umzugsablauf
              </h3>
              <div className="grid md:grid-cols-2 gap-4">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span className="text-slate-700">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-10 text-center text-white">
              <Calendar className="w-16 h-16 mx-auto mb-6 text-green-400" />
              <h3 className="text-3xl font-bold mb-4">
                Bereit für Ihren stressfreien Umzug?
              </h3>
              <p className="text-lg text-slate-300 mb-8 max-w-2xl mx-auto leading-relaxed">
                Kontaktieren Sie uns noch heute für eine kostenlose Beratung und Besichtigung. Wir planen Ihren Umzug von der Schweiz nach Deutschland professionell und zuverlässig.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                <button
                  onClick={scrollToContact}
                  className="bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-slate-100 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 inline-flex items-center space-x-2"
                >
                  <span>Jetzt kostenlose Beratung anfordern</span>
                  <ArrowRight className="w-5 h-5" />
                </button>
                <a
                  href="tel:0800700100"
                  className="flex items-center space-x-2 text-white hover:text-slate-200 font-semibold transition"
                >
                  <Phone className="w-5 h-5" />
                  <span>0800 700 100 (Gratis)</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Haben Sie Fragen zum Ablauf?
            </h2>
            <p className="text-xl text-slate-600 mb-8">
              Unser Team berät Sie gerne persönlich zu Ihrem Umzug
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <button
                onClick={scrollToContact}
                className="group bg-slate-800 hover:bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105 flex items-center space-x-2"
              >
                <span>Kostenlose Beratung vereinbaren</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <a
                href="tel:0800700100"
                className="flex items-center space-x-2 text-slate-800 hover:text-slate-900 font-semibold transition"
              >
                <Phone className="w-5 h-5" />
                <span>0800 700 100 (Gratis)</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <FAQ />
      <Contact />
    </div>
  );
}
